import moment from 'moment';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { formatDate, DATE_FORMAT_WITH_YEAR } from 'utils/date-formatter';

const DatePlaceholderStyled = styled.div``;

interface DateRangeProps {
  startDate: string | null;
  dueDate: string | null;
  placeholder?: string;
}

export const DateRange: React.FC<DateRangeProps> = ({
  startDate,
  dueDate,
  placeholder,
}) => {
  if (!startDate && !dueDate) {
    return <DatePlaceholderStyled>{placeholder}</DatePlaceholderStyled>;
  }

  const hasOnlyDueDate = startDate == null && !!dueDate;
  const startDateFormatted = startDate
    ? formatDate(startDate)
    : hasOnlyDueDate
    ? formatDate(dueDate)
    : '';
  const dueDateFormatted = dueDate ? formatDate(dueDate) : '';

  const isSameDate =
    startDateFormatted === dueDateFormatted || dueDateFormatted === '';

  const isToday =
    isSameDate &&
    moment(hasOnlyDueDate ? dueDate : startDate).isSame(moment(), 'day');

  const isTomorrow =
    isSameDate &&
    moment(hasOnlyDueDate ? dueDate : startDate).isSame(
      moment().add(1, 'days'),
      'day',
    );

  if (isToday || isTomorrow) {
    return (
      <span className="calendar_date_text">
        {`${moment(hasOnlyDueDate ? dueDate : startDate).format(
          DATE_FORMAT_WITH_YEAR,
        )} `}
        <span className="calendar_date_label">
          (
          {isToday ? (
            <FormattedMessage id="today" />
          ) : (
            <FormattedMessage id="tomorrow" />
          )}
          )
        </span>
      </span>
    );
  }

  return (
    <span className="calendar_date_text">
      {isSameDate
        ? startDateFormatted
        : `${startDateFormatted} - ${dueDateFormatted}`}
    </span>
  );
};
